<template lang="pug">
  div
    top-nav(headerColor="white")
    .placeholder(v-if="loading")
    transition(name="fade")
      .content.index(v-if='!loading')
        .grid.top-margin-8
          .col-12
            h1.h-xl.category(:style="textColor")
              | {{ title }}
          .col-12.hero-row
            .hero
              img.cover(:src="heroImage" :alt="heroAlt")
          .col-8_xs-12(data-push-left="off-4_xs-0")
            .copy.wysiwyg(v-html="content.main_text")
            .grid.no-margin
              .col-6_xs-12(v-for="child in children")
                .page
                  router-link(:to="route(child.uid)")
                    .captions-mobile
                      h2.subpage.h-l
                        | {{ child.content.title.toLowerCase() }}
                    .screen-smaller(:style="backgroundColor")
                      img.cover(
                        :src="pageHero(child.content.main_image, child.files)"
                        v-if="pageHero(child.content.main_image, child.files)"
                        :alt="child.content.title.toLowerCase()"
                      )
                      .imageless(v-if="!pageHero(child.content.main_image, child.files)")
                      .captions(:class="{ gradient: pageHero(child.content.main_image, child.files)}")
                        h2.subpage.h-l
                          | {{ child.content.title.toLowerCase() }}
    bottom-nav(footerColor="white")
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'

export default {
  name: 'generic-index',
  mixins: [DataMixin, ComponentMixin],

  created () {
    this.requestData(this.$route.name)
  },

  methods: {
    pageHero: function (name, files) {
      if (name.length > 0) {
        const file = files.find(item => item.filename === name)
        return file.url
      } else {
        return false
      }
    },

    route: function (uid) {
      const page = {name: this.$route.name + '-page', params: { id: uid }}
      const blog = {name: 'blog'}
      return uid === '600state' ? blog : page
    }
  },

  computed: {
    title: function () {
      return this.content.title.toLowerCase()
    },

    content: function () {
      return this.loadedData[this.$route.name].content
    },

    key: function () {
      return this.$route.name
    },

    files: function () {
      return this.loadedData[this.$route.name].files
    },

    children: function () {
      return this.loadedData[this.$route.name].children
    },

    hero: function () {
      const name = this.content.main_image
      return this.files.find(item => item.filename === name)
    },

    heroImage () {
      return this.hero.url
    },

    heroAlt: function () {
      return this.hero.meta.caption
    },

    textColor: function () {
      console.log(this.colors[this.category])
      return 'color: ' + this.colors[this.$route.name]
    },

    backgroundColor: function () {
      return 'background-color: ' + this.colors[this.$route.name]
    }

  },

  watch: {
    '$route' (to, from) {
      this.requestData(to.name)
    }
  }
}
</script>

<style lang="sass">
  @import '../styles/_variables'
  @import '../styles/_mixins'
  .index
    margin-top: $paddingTop
    @include respond-to(xs)
      margin-top: 2rem
      padding-top: 1rem
    .top-margin-8
     @include respond-to(xs)
      margin-top: 8rem
    .hero-row
      padding-bottom: 0
    .copy
      margin: 6rem 0
    .screen-smaller
      width: 100%
      height: 0
      padding-bottom: 100%
      position: relative
      @include respond-to(xs)
        padding-bottom: 0%
        height: unset
      .imageless
        display: none
        width: 100%
        height: 0
        padding-bottom: 52%
        @include respond-to(xs)
          display: block
      .captions, .captions-mobile
        width: 100%
        height: 70%
        opacity: 1
        color: white
        position: absolute
        bottom: 0
        &.gradient
          background: linear-gradient(rgba(255,255,255,0), rgba(0,0,0,0.9))
        h2
          position: absolute
          bottom: 0
          padding: 0 3.3rem 3.3rem 3.3rem
      .captions
        @include respond-to(xs)
          display: none
    .captions-mobile
      display: none
      @include respond-to(xs)
        display: block
</style>



// WEBPACK FOOTER //
// GenericIndex.vue?5284f745